// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2cv_p","content":"GlobalSearch_content__1PXyJ"};